import { useTranslation } from "react-i18next";
import Chip from "@Components/Decor/Chip";
import Tag from "@Components/Decor/Tag";
import { ClockIcon } from "@Icons/MainIcons";
import Star from "@Icons/MainIcons/StarIcon";
import { VoucherIcon } from "src/assets/Icons";
import Skewer from "@Components/Decor/Skewer";
import IconHolder from "@Components/Decor/IconHolder";
import Float from "@Components/Decor/Float";
import HeroVoucher from "../HeroVoucher/HeroVoucher";

function DiscountsIllustration() {
  const { t } = useTranslation();

  return (
    <div
      className="discounts-hero-decor-scroll pointer-events-none absolute end-0 top-6 h-26 w-38 shrink-0 lg:relative lg:end-auto lg:top-auto lg:h-64 lg:w-96"
      aria-hidden
    >
      <div className="scale-40 rtl:origin-top-left absolute end-0 top-0 h-64 w-96 origin-top-right lg:scale-100">
        <Skewer angle={8} className="absolute end-6 top-6 bg-transparent! p-0! not-italic">
          <Float duration={5.5} distance={-10}>
            <HeroVoucher
              label={t("Discounts.hero.voucherLabel")}
              title={t("Discounts.hero.voucherTitle")}
              subtitle={t("Discounts.hero.voucherSubtitle")}
              stub="%"
            />
          </Float>
        </Skewer>

        <div className="absolute end-0 top-0">
          <Float duration={4} delay={-1.2} distance={-6}>
            <IconHolder icon={<VoucherIcon className="aspect-square w-8 p-2 h-8" />} />
          </Float>
        </div>
        <div className="absolute end-8 top-44">
          <Float duration={3.5} delay={-0.6} distance={-6}>
            <IconHolder icon={<Star className="aspect-square w-8 p-2" />} />
          </Float>
        </div>
      </div>

      <div className="absolute inset-0 hidden lg:block">
        <div className="absolute -start-20 top-36">
          <Float duration={4.5} delay={-3}>
            <Skewer angle={-5}>
              <Tag
                className="px-3! py-2!"
                title={<span className="text-sm">{t("Discounts.hero.limitedTitle")}</span>}
                subtitle={t("Discounts.hero.limitedSubtitle")}
                icon={<ClockIcon className="bg-background-primary-lighter text-font-active h-full w-full rounded-full p-2" />}
              />
            </Skewer>
          </Float>
        </div>
      </div>
    </div>
  );
}

export default function DiscountsHero() {
  const { t } = useTranslation();

  return (
    <div className="relative flex w-full items-center justify-between gap-8">
      <div className="flex flex-col gap-4">
        <Chip
          title={t("Discounts.hero.badge")}
          icon={
            <div className="flex size-3 items-center justify-center">
              <div className="bg-font-active size-1.5 rounded-full" />
            </div>
          }
          className="text-xs! outline-none!"
        />
        <h1 className="font-poppins text-font-default text-4xl font-semibold md:text-5xl">{t("Discounts.title")}</h1>
        <p className="text-font-subtle text-sm leading-loose md:text-base">
          {t("Discounts.hero.subtitle")}{" "}
          <Skewer angle={3} className="px-2 py-1 font-bold!">
            {t("Discounts.hero.highlight")}
          </Skewer>
        </p>
      </div>
      <DiscountsIllustration />
    </div>
  );
}
